import { date } from '@ipfabric/utils';
import { easingFunctions } from './Easing';

type EasingType = keyof typeof easingFunctions;

export class Tween {
  from: number;
  to: number;
  duration: number;
  easing: EasingType;
  private time?: number;

  constructor(
    duration = 1000,
    from = 0,
    to = 1,
    easing: EasingType = 'linear',
  ) {
    if (duration <= 0) {
      throw new Error('Duration must be a positive number');
    }
    if (!easingFunctions[easing]) {
      throw new Error(`Easing function "${easing}" not found`);
    }

    this.from = from;
    this.to = to;
    this.duration = duration;
    this.easing = easing;
  }

  start = (): void => {
    this.time = date.getTs();
  };

  get tween(): number {
    if (this.time === undefined) {
      return this.from;
    }
    const now = date.getTs();
    const lapsed = Math.min(now - this.time, this.duration);
    const progress = lapsed / this.duration;
    const delta = this.to - this.from;
    return this.from + easingFunctions[this.easing](progress) * delta;
  }
}
